import { Outlet, useLocation } from "react-router-dom";
import Header from "./header/Header";
import "./Page.scss";
import SideNavigation from "./SideNavigation";
import { useAuth } from "../context/AuthContext";

const Page = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  const isViewerRoute =
    location.pathname === "/viewer" || location.pathname.startsWith("/viewer/");

  const showSideNavigation = isAuthenticated && !isViewerRoute;

  return (
    <div
      className={`page ${isAuthenticated ? "with-header" : ""} ${
        showSideNavigation ? "with-sidebar" : ""
      }`}
    >
      <Header dashboard={true}></Header>
      {showSideNavigation && <SideNavigation />}
      <Outlet />
      {children}
    </div>
  );
};

export default Page;
